<ng-from-track-header
  *ngIf="(store$ | async) as store"
  [inventoryTracks]="store.trackMoveState.tracks"
  [selectedToTrack]="store.trackMoveState.selectedToTrack"
  [fromTrackData]="store.trackMoveState.fromTrackData"
  [toTrackData]="store.trackMoveState.toTrackData"
  [fromTrackGrid]="fromTrackGrid"
  [toTrackGrid]="toTrackGrid"
  (fromTrackSelected)="dispatchSelectedTracK($event)"
  (move)="dispatchMove($event)"
  (adjust)="dispatchAdjust($event)"
  (refresh)="dispatchRefresh($event)"
></ng-from-track-header>
